<app-header></app-header>

<ng-container *ngIf="!hasError404">
  <h1
    class="main-title"
    [ngClass]="{
      'main-title_light-gray': category?.theme === 'gray' || !category
    }"
  >
    {{ category?.name }}
    <app-text-holder
      [desktopTexts]="[80, 140]"
      *ngIf="!category"
    ></app-text-holder>
  </h1>

  <div class="min90height">
    <div *ngIf="!isLoading && (!competitions || !competitions.length)">
      <aside class="alert alert_warn my-5">
        <p class="alert__text"> No raffles in this place </p>
      </aside>
    </div>

    <ng-container *ngIf="isLoading || (competitions && competitions.length)">
      <!--      <app-info-bar [hasconfettiDecor]="true"-->
      <!--                    *ngIf="category?.slug == 'current-tech-competitions'"></app-info-bar>-->

      <section
        class="section section_cards"
        [ngClass]="{
          'current-competitions__section': category?.showAllRaffles
        }"
      >
        <div class="container-wide" *ngIf="category?.showSorting">
          <div class="row">
            <header
              *ngIf="numberAllResults"
              class="current-competitions__data-header"
            >
              <p class="current-competitions__result-count"
                >Showing {{ numberFirstResult }}–{{ numberLastResult }} of
                {{ numberAllResults }} results</p
              >
              <select
                class="current-competitions__sort-options"
                (change)="handleFilter($event.target['value'])"
              >
                <option
                  *ngFor="let item of filters"
                  [value]="item.value"
                  [selected]="item.value === selectedFilter"
                  >{{ item.name }}</option
                >
              </select>
            </header>
          </div>
        </div>

        <div class="loading" *ngIf="isLoading">
          <div class="loading__icon">
            <svg-icon name="spinner" class="spinner"></svg-icon>
          </div>
        </div>

        <div
          *ngIf="competitions"
          [class.container-fluid]="category.containerFluid"
          [class.container-wide]="!category.containerFluid"
        >
          <div class="row">
            <app-raffle-card
              *ngFor="let raffle of competitions"
              [raffle]="raffle"
            ></app-raffle-card>

            <footer
              class="current-competitions__pagination-box"
              *ngIf="maxPages > 1"
            >
              <app-card-pagination
                [pageCount]="maxPages"
                [urlPattern]="'/' + category.slug + '/page/%s'"
                [currentPage]="this.page + 1"
              ></app-card-pagination>
            </footer>
          </div>
        </div>
      </section>
    </ng-container>
  </div>
</ng-container>

<app-not-found *ngIf="hasError404"></app-not-found>

<app-footer></app-footer>
